import { createSlice } from '@reduxjs/toolkit'

import { LANGUAGE_CODE } from '../../consts/app';


const localStorageLanguage = localStorage.getItem('language');

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    shareLocationWith: 1,  // friends
    keepScreenOn: true,
    newEventsAnonymous: false,
    newPinsPrivate: false,
    othersCanInvite: true,
    alwaysShowIntro: null,
    withinMeters: 100,
    language: localStorageLanguage && localStorageLanguage !== '0' ? localStorageLanguage : LANGUAGE_CODE,
  },
  reducers: {
    setShareLocationWith: (state, action) => {
      state.shareLocationWith = action.payload
    },
    setKeepScreenOn: (state, action) => {
      state.keepScreenOn = action.payload
    },
    setNewEventsAnonymous: (state, action) => {
      state.newEventsAnonymous = action.payload
    },
    setNewPinsPrivate: (state, action) => {
      state.newPinsPrivate = action.payload;
    },
    setOthersCanInvite: (state, action) => {
      state.othersCanInvite = action.payload;
    },
    setAlwaysShowIntro: (state, action) => {
      state.alwaysShowIntro = action.payload
    },
    setWithinMeters: (state, action) => {
      state.withinMeters = action.payload
    },
    setLanguage: (state, action) => {
      state.language = action.payload
    },
    resetSettings: (state) => {
      state.shareLocationWith = 1;
      state.keepScreenOn = true;
      state.newEventsAnonymous = false;
      state.alwaysShowIntro = null;
      // state.withinMeters = 100;
      // state.language = LANGUAGE_CODE;
    },
  },
})

export const {
  resetSettings,
  setAlwaysShowIntro,
  setKeepScreenOn,
  setLanguage,
  setNewEventsAnonymous,
  setNewPinsPrivate,
  setOthersCanInvite,
  setShareLocationWith,
  setWithinMeters,
} = settingsSlice.actions;

export default settingsSlice.reducer;